// 9fbef606107a605d69c0edbcd8029e5d
import { DY_RECOMMENDATIONS_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

export const FETCH_DY_RECOMMENDATIONS_DATA = `${DY_RECOMMENDATIONS_ACTION_PATTERN}FETCH_DY_RECOMMENDATIONS_DATA`;
export const SET_DY_RECOMMENDATIONS_DATA = `${DY_RECOMMENDATIONS_ACTION_PATTERN}SET_DY_RECOMMENDATIONS_DATA`;
export const SET_DY_LOADING_STATE = `${DY_RECOMMENDATIONS_ACTION_PATTERN}SET_DY_LOADING_STATE`;
export const CLEAR_DY_RECOMMENDATIONS_DATA = `${DY_RECOMMENDATIONS_ACTION_PATTERN}CLEAR_DY_RECOMMENDATIONS_DATA`;
export const SEND_TRACK_EVENTS_TO_DY = `${DY_RECOMMENDATIONS_ACTION_PATTERN}SEND_TRACK_EVENTS_TO_DY`;